import { render, staticRenderFns } from "./SlagIronParaEdit.vue?vue&type=template&id=420d7c9a&"
import script from "./SlagIronParaEdit.vue?vue&type=script&lang=js&"
export * from "./SlagIronParaEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports